import { createSelector } from 'reselect';

export function getLotteryState(state) {
  return state.pending;
}

export function getShowAnimation(state) {
  return state.showAnimation;
}

export function getDrumRollSound(state) {
  return state.drumRollSound;
}

export function getWinnerSound(state) {
  return state.winnerSound;
}

export function getIsSnackBar(state) {
  return state.isSnackBar;
}

export function getMessage(state) {
  return state.message;
}

export function getNumberOfWinner(state) {
  return state.numberOfWinner;
}

export function getLotteries(state) {
  return state.lotteries;
}

export function getLotteryList(state) {
  return getLotteries(state).list;
}

//= ====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getVisibleLotteries = createSelector(
  getLotteryList,
  (lotteries, filter) => {
    switch (filter) {
      case 'active':
        return lotteries.filter(lottery => !lottery.completed);

      case 'completed':
        return lotteries.filter(lottery => lottery.completed);

      default:
        return lotteries;
    }
  },
);



// WEBPACK FOOTER //
// ./src/core/lotteries/selectors.js